import src from "IMAGE";
export default { src, width: 1, height: 1, blurWidth: 8, blurHeight: 8, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAQAAABuBnYAAAAAFUlEQVR42s3AgQAAAACAoPyp1zgeAgCIAAGHpgLFAAAAAElFTkSuQmCC"};
